import React from 'react'
import styles from '@/src/components/scss/Schedule.module.scss'
import { Box } from '@mui/material'
import { Typography, Button } from '@evocolabs/orkaui'
import { useSchedule } from '@/components/Schedule/ScheduleRoot'
import { useCalendar } from '@/components/Schedule/Calendar/CalendarProvider'

const AppointmentCancelled = () => {
  const { viewId, setViewId, history, setDate, setTime } = useSchedule()
  const { refreshAvailableTimeSlots } = useCalendar()

  async function handleReschedule() {
    setDate({
      year: null,
      month: null,
      date: null
    })
    setTime({
      idx: -1,
      start: -1,
      end: -1
    })
    await refreshAvailableTimeSlots()
    history.push(viewId)
    setViewId(viewId - 2)
  }

  return (
    <Box className={styles.viewRoot}>
      <Typography variant="h3">Appointment Canceled</Typography>
      <Typography variant="body1" sx={{ mt: '16px' }}>
        Your appointment has been cancelled. You can reschedule your
        consultation by clicking the button.
      </Typography>
      <Box sx={{ textAlign: 'left', mt: '24px' }}>
        <Button size="large" handleClick={handleReschedule} loadable>
          reschedule
        </Button>
      </Box>
    </Box>
  )
}

export default AppointmentCancelled
